export default __webpack_public_path__ + "static/media/teeth-operation.928305bb.png";